var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tooltip"},[_vm._t("component"),(_vm.isVisible)?_c('span',{staticClass:"ui-tooltiptext"},[_vm._t("alert-text")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }